import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import { useInstance } from 'intact-vue';
import { containsOrEqual } from '../../hooks/useDocumentClick';
import { useState } from '../../hooks/useState';
export var Mode;
(function (Mode) {
  Mode[Mode["Before"] = 0] = "Before";
  Mode[Mode["After"] = 1] = "After";
  Mode[Mode["Inner"] = 2] = "Inner";
})(Mode || (Mode = {}));
export var RANGE = 0.25;
export function useDraggable() {
  var instance = useInstance();
  var draggingKey = useState(null);
  var overKey = useState(null);
  var mode = useState(null);
  var draggingDom = null;
  var draggingNode = null;
  var overNode = null;
  var clientX = null;
  var clientY = null;
  var valid = false;
  function onDragStart(node, e) {
    e.stopPropagation();
    var _instance$get = instance.get(),
      allowDrag = _instance$get.allowDrag;
    if (node.data.disabled || allowDrag && !allowDrag(node)) {
      instance.trigger('denydrag', node);
      e.preventDefault();
      return;
    }
    draggingDom = e.target;
    draggingNode = node;
    draggingKey.set(node.key);
  }
  function onDragOver(node, e) {
    e.stopPropagation();
    e.preventDefault();
    var overDom = e.target;
    if (containsOrEqual(draggingDom, overDom)) return;
    // ignore the over event, it the mouse does not move
    var newClientX = e.clientX,
      newClientY = e.clientY;
    if (clientX === newClientX && clientY === newClientY) return;
    clientX = newClientX;
    clientY = newClientY;
    var newMode = calcInserMode(e, overDom);
    if (node !== overNode || newMode !== mode.value) {
      overNode = node;
      mode.set(newMode);
      overKey.set(node.key);
      // if the node does not allow drop, prevent the dragging node from inserting to it
      // if (mode.value === Mode.Inner) {
      var _instance$get2 = instance.get(),
        allowDrop = _instance$get2.allowDrop;
      if (node.data.disabled || allowDrop && !allowDrop(node, draggingNode, newMode)) {
        instance.trigger('denydrop', node, draggingNode, newMode);
        valid = false;
        return;
      }
      // }
      valid = true;
    }
  }
  function calcInserMode(e, dom) {
    var clientY = e.clientY;
    var _dom$getBoundingClien = dom.getBoundingClientRect(),
      top = _dom$getBoundingClien.top,
      bottom = _dom$getBoundingClien.bottom,
      height = _dom$getBoundingClien.height;
    var des = height * RANGE;
    if (clientY <= top + des) return Mode.Before;else if (clientY >= bottom - des) return Mode.After;
    return Mode.Inner;
  }
  function onDragEnd(e) {
    e.stopPropagation();
    e.preventDefault();
    if (valid) {
      handleData();
      instance.trigger('dragend', {
        srcNode: draggingNode,
        toNode: overNode,
        mode: mode.value
      });
    }
    draggingKey.set(null);
    mode.set(null);
    draggingDom = null;
    draggingNode = null;
    overNode = null;
    clientX = null;
    clientY = null;
    valid = false;
  }
  function handleData() {
    var _context;
    var _instance$get3 = instance.get(),
      data = _instance$get3.data;
    // remove node firstly
    remove(draggingNode, data);
    switch (mode.value) {
      case Mode.Before:
        insert(overNode, draggingNode, data, 0);
        break;
      case Mode.After:
        insert(overNode, draggingNode, data, 1);
        break;
      case Mode.Inner:
        append(overNode, draggingNode);
        instance.expand(overNode.key);
        break;
    }
    instance.set('data', _concatInstanceProperty(_context = []).call(_context, data));
  }
  return {
    onDragStart: onDragStart,
    onDragOver: onDragOver,
    onDragEnd: onDragEnd,
    draggingKey: draggingKey,
    overKey: overKey,
    mode: mode
  };
}
function remove(node, data) {
  var siblings = getNodeSiblings(node, data);
  var index = siblings.indexOf(node.data);
  _spliceInstanceProperty(siblings).call(siblings, index, 1);
}
function insert(node, newNode, data, offset) {
  var siblings = getNodeSiblings(node, data);
  var index = siblings.indexOf(node.data);
  _spliceInstanceProperty(siblings).call(siblings, index + offset, 0, newNode.data);
}
function append(node, newNode) {
  var children = node.data.children || (node.data.children = []);
  children.push(newNode.data);
}
function getNodeSiblings(node, data) {
  var parent = node.parent;
  return parent ? parent.data.children : data;
}